<script>
require('@/css/style.css')

export default {
  props: ['id', 'x1', 'y1', 'x2', 'y2', 'nodeMarginY', 'nodeHeight'],
  data () {
    return {
      edgeWidth: 10,
      strokeWidth: 3,
      strokeColor: '#ffaac8',
      opacityValue: 1.0,
      zIndex: -1,
      posY1: this.y1,
      posY2: this.y2,
      heightY: 0
    }
  },
  created () {
    this.renderAnchors()
  },
  watch: {
    x1: function (val) {
      this.renderAnchors()
    },
    y1: function (val) {
      this.renderAnchors()
    }
  },
  methods: {
    renderAnchors () {
      if (this.y1 > this.y2) {
        this.posY1 = this.y1
        this.posY2 = this.y2 + this.nodeHeight - this.nodeMarginY
      } else if (this.y1 < this.y2) {
        this.posY1 = this.y1 + this.nodeHeight - this.nodeMarginY
        this.posY2 = this.y2
      } else {
        this.posY1 = this.y1 + this.nodeMarginY
        this.posY2 = this.y2 + this.nodeMarginY
      }
      this.heightY = (Math.abs(this.y2 - this.y1) === 0) ? this.nodeHeight : Math.abs(this.y2 - this.y1)
    }
  }
}
</script>
<style scoped>
.edge {
  position:absolute;
}
.line {
  transition: all 0.3s ease 0s;
}
.line:hover {
  stroke-width: 6;
  stroke-opacity: 1;
}
</style>
<template>
<div class="edge" :style="{left:Math.min(x1, x2) + 'px', top:Math.min(y1, y2) + 'px', width:Math.abs(x2-x1) + edgeWidth + 'px', height: heightY + 'px', 'z-index':zIndex}">
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
    <line class="line" :x1="x1 - Math.min(x1, x2)" :y1="posY1 - Math.min(y1, y2)" :x2="x2 - Math.min(x1, x2)" :y2="posY2 - Math.min(y1, y2)" :stroke="strokeColor" :stroke-width="strokeWidth" :stroke-opacity="opacityValue"/>
  </svg>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/GraphAnchor.vue